import { useMemo } from 'react';
import { useCriticalEvents } from '@src/services/queries';

const useMilestonesEvents = () => {
  const { data } = useCriticalEvents();
  const milestoneEvents = useMemo(() => data?.criticalEvents ?? [], [data]);

  // Convert events to select options
  const eventOptions = useMemo(() => {
    return milestoneEvents.map((event) => ({
      label: event.name,
      value: event.id,
      event: event,
    }));
  }, [milestoneEvents]);

  return {
    milestoneEvents,
    eventOptions,
  };
};

export default useMilestonesEvents;
